import request from './../../../common/RemoteApiService';

const endpoints = window.config.api.endpoints;
const baseUrl = window.config.api.baseUrl;

export const authenticate = async (username, password) => {

  const response = await request('GET', endpoints.authentication.get(baseUrl), null, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Basic ' + btoa(username + ':' + password)
    }
  });

  return response.json();
};
